import axios from 'axios';

export const UploadLogo = async (formData: FormData) => {
  const resUrlRecord = await axios.post('/storages/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return resUrlRecord.data.url;
};

export const DeleteLogo = () => axios.delete('/storages/logo');

export const getAdminSystemInfo = async () => {
  const { data } = await axios.get('/system/info');
  return data;
};
export const uploadLogoClient = async (idClient: number, formData: FormData) => {
  const resUrlRecord = await axios.post(`/storages/client-photos/${idClient}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return resUrlRecord.data.url;
};
